import styled from 'styled-components';

const Picture = styled.div`
    margin-right: 10px;
`;

export default Picture;
